var map = {
	"./BioTraceOceanWaves001.jpg": "d6b9",
	"./BioTraceOceanWaves002.jpg": "7c03",
	"./BioTraceOceanWaves003.jpg": "48d4",
	"./BioTraceOceanWaves004.jpg": "210c",
	"./BioTraceOceanWaves005.jpg": "c28f",
	"./BioTraceOceanWaves006.jpg": "e6f6",
	"./BioTraceOceanWaves007.jpg": "2778",
	"./BioTraceOceanWaves008.jpg": "d938",
	"./BioTraceOceanWaves009.jpg": "b6c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6361c";